import { render, staticRenderFns } from "./export-archive.html?vue&type=template&id=930a9a7a&scoped=true&"
import script from "./export-archive.ts?vue&type=script&lang=ts&"
export * from "./export-archive.ts?vue&type=script&lang=ts&"
import style0 from "./export-archive.scss?vue&type=style&index=0&id=930a9a7a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "930a9a7a",
  null
  
)

/* custom blocks */
import block0 from "./export-archive.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fviews%2Farchive%2Fexport-archive%2Fexport-archive.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardText,VCardTitle,VIcon})
